import React from 'react'
import type { HeadingLevel } from 'src/typings/headingTags'
import DynamicHeadingTags from 'src/components/common/DynamicHeadingTags/DynamicHeadingTags'
import './styles.scss'

interface HeaderProps {
  title: string | undefined
  heading: string
  fontfamily: string
}
const InsiderShelfHeader: React.FC<HeaderProps> = ({ title, heading, fontfamily }) => {
  if (!title || !heading) return null
  return (
    <div className="shelf-header">
      <DynamicHeadingTags
        className="insider-shelf__title"
        as={heading as HeadingLevel}
        style={{
          fontFamily: fontfamily === '2' ? 'roboto' : 'Cormorant Garamond',
        }}
      >
        {title}
      </DynamicHeadingTags>
    </div>
  )
}
export default InsiderShelfHeader
